import React, { useRef, useEffect } from 'react';
import './calltoaction.css';
import { Link } from 'react-router-dom';

const CallToAction = () => {
    const canvasRef = useRef(null);
    let particles = [];
    const numParticles = 100;
    const maxConnectionDistance = 100; // Maximum distance for connecting particles
    const particleSpeed = 1; // Adjust particle speed

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        function Particle(x, y) {
            this.x = x;
            this.y = y;
            this.radius = 2;
            this.color = '#ffffff';
            this.connections = [];
            this.velocity = {
                x: Math.random() * particleSpeed * 2 - particleSpeed,
                y: Math.random() * particleSpeed * 2 - particleSpeed
            };
        }

        Particle.prototype.draw = function() {
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
            ctx.fillStyle = this.color;
            ctx.fill();
            ctx.closePath();
        };

        Particle.prototype.update = function() {
            this.x += this.velocity.x;
            this.y += this.velocity.y;

            // Check canvas boundaries and reverse particle velocity if out of bounds
            if (this.x + this.radius > canvas.width || this.x - this.radius < 0) {
                this.velocity.x = -this.velocity.x;
            }
            if (this.y + this.radius > canvas.height || this.y - this.radius < 0) {
                this.velocity.y = -this.velocity.y;
            }

            this.draw();
        };

        function connectParticles() {
            for (let i = 0; i < particles.length; i++) {
                for (let j = i + 1; j < particles.length; j++) {
                    const dx = particles[i].x - particles[j].x;
                    const dy = particles[i].y - particles[j].y;
                    const distance = Math.sqrt(dx * dx + dy * dy);

                    if (distance < maxConnectionDistance) {
                        ctx.beginPath();
                        ctx.moveTo(particles[i].x, particles[i].y);
                        ctx.lineTo(particles[j].x, particles[j].y);
                        ctx.strokeStyle = '#ffffff';
                        ctx.lineWidth = 0.1;
                        ctx.stroke();
                        ctx.closePath();

                        particles[i].connections.push(particles[j]);
                        particles[j].connections.push(particles[i]);
                    }
                }
            }
        }

        function init() {
            particles = [];
            for (let i = 0; i < numParticles; i++) {
                const x = Math.random() * canvas.width;
                const y = Math.random() * canvas.height;
                particles.push(new Particle(x, y));
            }
        }

        function animate() {
            requestAnimationFrame(animate);
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            connectParticles();

            particles.forEach(particle => {
                particle.update();
            });
        }

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        init();
        animate();

        window.addEventListener('resize', () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
            init();
        });

        canvas.addEventListener('mousemove', (event) => {
            const mouseX = event.clientX;
            const mouseY = event.clientY;

            particles.forEach(particle => {
                const dx = particle.x - mouseX;
                const dy = particle.y - mouseY;
                const distance = Math.sqrt(dx * dx + dy * dy);

                if (distance < 50) { // Increase this value to adjust the interaction radius
                    const angle = Math.atan2(dy, dx);
                    particle.velocity.x = Math.cos(angle) * particleSpeed * 2;
                    particle.velocity.y = Math.sin(angle) * particleSpeed * 2;
                }
            });
        });

        canvas.addEventListener('mouseleave', () => {
            particles.forEach(particle => {
                particle.velocity.x = Math.random() * particleSpeed * 2 - particleSpeed;
                particle.velocity.y = Math.random() * particleSpeed * 2 - particleSpeed;
            });
        });

        return () => {
            window.removeEventListener('resize', () => {});
            canvas.removeEventListener('mousemove', () => {});
            canvas.removeEventListener('mouseleave', () => {});
        };
    }, []);

    return (
<div className="call-to-action">
  <canvas ref={canvasRef} className="particles"></canvas>
  <div className="cta-content">
    <h2 className="animated-text">Get Connected</h2>
    <p className="animated-text">Let's collaborate on your next project or discuss opportunities.</p>
    <div className='primary-btn-container'>
      <Link to="/contact">
        <button className="primary-button">Get in Touch</button>
      </Link>
    </div>
  </div>
</div>
      );
};

export default CallToAction;